// extracted by mini-css-extract-plugin
export default {"item":"DocumentLayoutListItem_item__8EuLW","title":"DocumentLayoutListItem_title__1jSLM"};